import lengthConfig from '../config/length';

import validateLength from './length';

export const validateRsyPlatformId = (value: string): string =>
    validateLength(value, lengthConfig.rsyPlatformId, 'field-id');
